<template lang="pug">
  #dashboard-redeem-award-points
    WtTitle(card-title) Points
    p You have {{ apBalance }} award points to spend.
    br
    WtButton(
      color="primary"
      size="medium"
      @click.native="redeemAwardPoints()"
      ) Redeem Award Points
</template>

<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";

export default {
  name: "DashboardRedeemAwardPoints",
  components: {
    WtButton,
    WtTitle
  },
  data() {
    return {
      apBalance: this.getAwardPointsBalance()
    };
  },
  methods: {
    getAwardPointsBalance() {
      let awardPointsBalance = localStorage.getItem("AwardPointsBalance");

      if (awardPointsBalance === null) {
        return 0;
      }

      return awardPointsBalance;
    },
    async redeemAwardPoints() {
      try {
        await this.axios.get("award-points/grs").then(response => {
          if (response.status === 200) {
            window.open(response.data, "_blank", "noreferrer");
          } else {
            this.showErrorDialog();
          }
        });
      } catch (error) {
        this.showErrorDialog();
      }
    },
    showErrorDialog() {
      this.$buefy.dialog.alert({
        title: "Error!",
        type: "is-danger",
        message:
          "We were unable to log you into the award points redemption platform, please contact wellness@be-engaged.co for assistance."
      });
    }
  }
};
</script>

<style lang="sass" scoped></style>
